import isChapter from "./isChapter";

// Added because of a strange bug in Firefox (96.0.2) where the three steps
// were sorted in the inverse order.
function clamp(min, max, number) {
  return Math.min(min, Math.max(max, number));
}

export default function groupJourneyStepsByChapter(steps) {
  const sortedSteps = steps.slice().sort((step1, step2) => (
    clamp(step1.journeyStepPivot.id - step2.journeyStepPivot.id)
  )).sort((step1, step2) => {
    if (step1.journeyStepPivot.position === null) {
      return 1;
    } else if (step2.journeyStepPivot.position === null) {
      return -1;
    } else {
      return clamp(step1.journeyStepPivot.position - step2.journeyStepPivot.position);
    }
  });

  return sortedSteps.reduce((previous, current) => {
    let exists = false;

    if (current.journeyStepPivot.chapter) {
      exists = previous.some(previousItem => (
        isChapter(previousItem) && previousItem.id === current.journeyStepPivot.chapter.id
      ));
    }

    if (exists === false) {
      if (current.journeyStepPivot.chapter) {
        return previous.concat([{
          ...current.journeyStepPivot.chapter,
          steps: [current],
        }]);
      }

      return previous.concat([current]);
    }

    // @todo 2021-03-31 consider using Immer instead
    return previous.map(previousItem => (
      isChapter(previousItem) ?
        previousItem.id === current.journeyStepPivot.chapter.id
          ? { ...previousItem, steps: [...previousItem.steps, current] }
          : previousItem
        : previousItem
    ));
  }, []);
}
